export const ethereumAddressRegexp: RegExp = /^(0x)?[0-9a-f]{40}$/i;
